import React from 'react';
import { useTranslation } from 'react-i18next';

export default function TermsConditions() {
  const { t } = useTranslation("global");

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">{t('terms.title')}</h2>
      <p className="text-center mb-5">{t('terms.subtitle')}</p>

      <div className="mb-4">
        <h4>{t('terms.account.title')}</h4>
        <p>{t('terms.account.description')}</p>
      </div>

      <div className="mb-4">
        <h4>{t('terms.courses.title')}</h4>
        <p>{t('terms.courses.description')}</p>
      </div>

      <div className="mb-4">
        <h4>{t('terms.payments.title')}</h4>
        <p>{t('terms.payments.description')}</p>
      </div>

      <div className="mb-4">
        <h4>{t('terms.conduct.title')}</h4>
        <p>{t('terms.conduct.description')}</p>
      </div>
    </div>
  );
}
